import React from 'react';

import { FeatureFlagged, FeatureGatedVariant } from '../../../feature-gates/feature-flagged';
import { FeatureGates } from '../../../feature-gates/feature-gates';
import { UiMessageBanner } from '../../../ui/ui-message-banner';

import { LegacyAutomationWarning } from './legacy-automation-warning';

type IssueDetails = { object: string; field: string; reason?: string; percentCorrect?: number };

const AutomationIssueMessage = ({ missingFieldIssue }: { missingFieldIssue: IssueDetails }) => (
  <div>
    {missingFieldIssue.object} {missingFieldIssue.object.slice(-1) === 's' ? 'are' : 'is'} missing{' '}
    <span className="typo-bold">{missingFieldIssue.field}</span>{' '}
    {missingFieldIssue.reason
      ? `needed for the
  ${missingFieldIssue.reason}.`
      : '.'}
  </div>
);

export const AutomationWarning = ({
  missingFieldIssue,
  variant,
  link,
  action,
  className,
}: {
  missingFieldIssue: IssueDetails;
  variant: 'employeeIssue' | 'automationIssue';
  link?: string;
  action?: () => void;
  className?: string;
}) => {
  let bannerAction;
  if (link) {
    bannerAction = { name: 'View Issues', link };
  } else if (action) {
    bannerAction = { name: 'Fix Now', handler: action };
  }

  const employeeIssueMessage =
    missingFieldIssue.percentCorrect !== undefined && missingFieldIssue.percentCorrect < 50
      ? `The majority of ${missingFieldIssue.object} are missing ${missingFieldIssue.field} and will not trigger automations`
      : `${missingFieldIssue.percentCorrect}% of ${missingFieldIssue.object} have ${missingFieldIssue.field} and will trigger automations`;

  return (
    <>
      <FeatureFlagged
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <LegacyAutomationWarning
          missingFieldIssue={missingFieldIssue}
          variant={variant}
          action={action}
          className={className}
          link={link}
        />
      </FeatureFlagged>
      <FeatureFlagged
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <UiMessageBanner
          variant="attention"
          className={`u-margin-bottom-xl u-margin-top ${className || ''}`}
          action={bannerAction}
          message={variant === 'employeeIssue' ? employeeIssueMessage : ''}
        >
          {variant === 'automationIssue' && (
            <AutomationIssueMessage missingFieldIssue={missingFieldIssue} />
          )}
        </UiMessageBanner>
      </FeatureFlagged>
    </>
  );
};
